'use client'

import dynamic from 'next/dynamic'
import React from 'react'

import Form from '@/components/Form/Organisms/SurveyForm/Form'
import FormLogic from '@/components/Form/Organisms/SurveyForm/Form/FormLogic'
import NpsFormLogic from '@/components/Form/Organisms/SurveyForm/Form/NpsFormLogic'

const UnderSurveyFormLogic = dynamic(
  () => import('@/components/Form/Organisms/SurveyForm/UnderSurveyForm/UnderSurveyFormLogic'),
  {
    ssr: false,
  }
)

export default function UnderSurveyForm({
  symbol,
  productIds,
  nps = false,
}: {
  symbol: string
  productIds: string[]
  nps?: boolean
}) {
  return (
    <>
      <UnderSurveyFormLogic symbol={symbol} productIds={productIds}>
        {(survey, afterSubmit) => {
          return (
            <Form
              survey={survey}
              afterSubmit={afterSubmit}
              FormComponent={nps ? NpsFormLogic : FormLogic}
              simple={true}
            />
          )
        }}
      </UnderSurveyFormLogic>
    </>
  )
}
